<script setup lang="ts" generic="T">
interface Props<T> {
  itemList: T[];
}
defineProps<Props<T>>();
const emit = defineEmits(["click:item"]);
const cardBodyClass = [
  "p-0",
  "py-4",
  "px-6",
  "border",
  "border-solid",
  "rounded",
  "border-gray-300",
  "cursor-pointer",
  "hover:bg-primary-50",
];

function onItemClick(item: T) {
  emit("click:item", item);
}
</script>

<template>
  <div class="inline-grid grid-cols-4 gap-4">
    <!-- Loop through items and provide slot for each item -->
    <a
      v-for="(item, index) in itemList"
      :key="index"
      :class="cardBodyClass"
      @click="onItemClick(item)"
    >
      <!-- Using scoped slot with type safety -->
      <slot name="cardContent" :item="item" />
    </a>
  </div>
</template>
